export const fieldNames = Object.freeze({
  name: 'name',
  typeId: 'typeId',
  type: 'type',
});

export const fieldTypes = Object.freeze({
  director: 'director',
  address: 'address',
  phone: 'phone',
  email: 'email',
  inn: 'inn',
  site: 'site',
  schedule: 'schedule',
  information: 'information',
  specialization: 'specialization',
  kpp: 'kpp',
});

/*
export const fieldLabels = Object.freeze({
  [fieldTypes.director]: 'Директор',
  [fieldTypes.address]: 'Адрес',
  [fieldTypes.phone]: 'Телефон',
  [fieldTypes.email]: 'Почта',
  [fieldTypes.inn]: 'ИНН',
  [fieldTypes.site]: 'Сайт',
  [fieldTypes.schedule]: 'Время',
  [fieldTypes.information]: 'Описание',
  [fieldTypes.specialization]: 'Область работы',
});
*/
